exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-card {\n  border-radius: 10px !important;\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);\n}\n#contactEmailIcon svg path {\n  fill: #6236ff;\n}\n", ""]);

// exports
